<div class="loginform">
  <div class="row justify-content-center">
    <img class="profile-img px-3" src="assets/images/logo-login.png" alt="" />
  </div>
  <div class="row justify-content-center">
    <h1 class="text-center login-title"><strong>Sign in to access your account</strong></h1>
  </div>
  <div class="row justify-content-center">
    @if (!double_auth) {
      <div>
        <form class="form-signin form-group">
          <div class="form-group">
            <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="userId" id="sign_user_id" type="text" class="form-control" placeholder="User id" autocomplete="username" required autofocus />
          </div>
          <div class="form-group password-field">
            <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="password" [type]="passwordVisible ? 'text' : 'password'" id="sign_password" placeholder="Password" class="form-control password-input" autocomplete="current-password" required />
            <i class="toggle-password pi" [ngClass]="passwordVisible ? 'pi-eye-slash' : 'pi-eye'" (click)="togglePasswordVisibility()" aria-label="Toggle password visibility" role="button" tabindex="0"></i>
          </div>
          <div class="form-group">
            <p-button label="Sign in" styleClass="bigger-login-button w-100" severity="primary" size="large" (onClick)="login()"></p-button>
          </div>
          @if (msg) {
            <div class="alert alert-warning">{{ msg }}</div>
          }
          <div class="form-group">
            <span class="lost">Lost your password?</span>
            <p-button severity="danger" size="small" (onClick)="password_reset_request()" label="RESET"></p-button>
          </div>
        </form>
      </div>
    }
    @if (double_auth) {
      <div>
        <form class="form-signin">
          <div class="alert alert-warning">Double authentication is needed for admin access!!</div>
          <hr />
          <div class="alert alert-info">
            <div class="glyphicon glyphicon-save"></div>
            Insert your u2f device and press device
          </div>
          @if (msg) {
            <div class="alert alert-success">{{ msg }}</div>
          }
          @if (error_msg) {
            <div class="alert alert-danger">{{ error_msg }}</div>
          }
          @if (userData && userData.otp && userData.otp.secret) {
            <div class="row">
              <div class="col-md-12">
                <h4 class="text-center login-title"><strong>or</strong></h4>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input autocomplete="one-time-code" [ngModelOptions]="{ standalone: true }" [(ngModel)]="otp_token" type="text" class="form-control" placeholder="OTP token" autofocus />
                </div>
              </div>
              <div class="col-md-4">
                <p-button type="button" severity="primary" size="small" (click)="manageOTP()" label="Check OTP token"></p-button>
              </div>
            </div>
          }
          <h4 class="text-center login-title"><strong>or</strong></h4>
          <div class="alert alert-info">
            <div class="glyphicon glyphicon-envelope"></div>
            Request a temporary email token
          </div>
          <div class="row">
            <div class="col-md-4">
              <p-button type="button" styleClass="p-button p-button-primary" size="small" (click)="request_email_token()">Request</p-button>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <input autocomplete="one-time-code" [ngModelOptions]="{ standalone: true }" [(ngModel)]="mail_token" type="text" class="form-control" placeholder="Token received" autofocus />
              </div>
            </div>
          </div>
          @if (mail_token) {
            <p-button type="button" styleClass="p-button p-button-primary btn-block" size="large" [ngStyle]="{ display: 'block' }" (click)="validate_email_token()">Check token</p-button>
          }
        </form>
      </div>
    }
  </div>
  <div class="form-signin">
    <hr />
  </div>
  @if (!double_auth) {
    <div class="row justify-content-center">
      <h1 class="text-center login-title"><strong>or</strong></h1>
    </div>
  }
  <div class="row justify-content-center">
    <form class="form-signin">
      <p-button routerLink="/register" styleClass="bigger-login-button w-100" size="large" label="Create an account"></p-button>
    </form>
  </div>
</div>
